(() => {
  const initialisePlaylist = (playlist) => {
    if (playlist.dataset.peakPlaylistReady === 'true') return;
    const videos = Array.from(playlist.querySelectorAll('.peak-editorial-home__playlist-video'));
    if (!videos.length) return;

    playlist.dataset.peakPlaylistReady = 'true';
    let activeIndex = 0;
    const isVisible = () => window.getComputedStyle(playlist).display !== 'none';

    const playVideo = (index) => {
      activeIndex = index % videos.length;
      videos.forEach((video, videoIndex) => {
        const active = videoIndex === activeIndex;
        video.classList.toggle('is-active', active);
        if (!active) video.pause();
      });

      const activeVideo = videos[activeIndex];
      activeVideo.currentTime = 0;
      if (isVisible()) activeVideo.play().catch(() => {});
    };

    videos.forEach((video, index) => {
      video.muted = true;
      video.addEventListener('ended', () => playVideo(index + 1));
    });

    playVideo(0);
    window.addEventListener('resize', () => {
      if (isVisible()) videos[activeIndex].play().catch(() => {});
      else videos[activeIndex].pause();
    }, { passive: true });
  };

  const initialise = (root = document) => {
    root.querySelectorAll('[data-peak-video-playlist]').forEach(initialisePlaylist);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
